export const IDENTITY_INVALIDATED = "IDENTITY_INVALIDATED";
export const GET_IDENTITY_SUCCESS = "GET_IDENTITY_SUCCESS";
export const GET_IDENTITY_FAILURE = "GET_IDENTITY_FAILURE";
